import { render, staticRenderFns } from "./ChooseLevel.vue?vue&type=template&id=66836f25&scoped=true"
import script from "./ChooseLevel.vue?vue&type=script&lang=js"
export * from "./ChooseLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66836f25",
  null
  
)

export default component.exports